import { render } from "./TileBoxes.vue?vue&type=template&id=22340e04&scoped=true"
import script from "./TileBoxes.vue?vue&type=script&lang=js"
export * from "./TileBoxes.vue?vue&type=script&lang=js"

import "./TileBoxes.vue?vue&type=style&index=0&id=22340e04&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aryav\\Desktop\\Don't touch this file\\Talreq\\talreq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22340e04"]])

export default __exports__